<template>
  <div class="queryOrder">
    <!-- <div class="nav_bar">
      <van-nav-bar title="停车缴费" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>
    </div> -->
    <div class="advertising" style="margin: 3%" v-if="url!=''">
      <img :src="url" @click="clickUrl()" width="100%" height="100%" />
    </div>
    <div class="car_num_holder"></div>
    <carNum-input @getcarNum="getcarNum"></carNum-input>
    <van-button class="bt_qurey" color="#f47b20" @click="noPayRecord">查询补缴费用</van-button>
  </div>
</template>

<script>
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    name: "queryOrder",
    data() {
      return {
        url: "", //展示图片
        cUrl: "", //点击跳转地址
        title: "",
        active: "2",
        carNum: "",
        openid: "",
      };
    },
    methods: {
      onClickLeft() {
        console.log("返回");
        this.$router.push("/menu");
      },
      getcarNum(carNum) {
        console.log(carNum);
        this.carNum = carNum;
      },
      //跳转到补缴列表
      noPayRecord() {
        if(this.carNum.length<7){
          return this.$toast.fail("请输入完整车牌");
        }
        this.$router.push({
          path: '/payFeesRecord',
          query: {
            carNum: this.carNum,
          }
        });
      },
      //获取openId
      getopenId() {
        if (mySessionStorage.getItem("openid") != null && mySessionStorage.getItem("openid") != "" && mySessionStorage.getItem("openid") != "") {
          this.openid = mySessionStorage.getItem("openid");
        } else {
          this.$getOpenid().then(res => {
            this.openid = mySessionStorage.getItem("openid");
            console.log("--------------------------", this.openid);
          });
        }
      },
      //广告加载
      getAdvertisingInfo() {
        this.$axios({
            url: this.$api.payDetails,
            method: "get",
          })
          .then(res => {
            this.url = res.data.data.creativeImg.creativeUrl;
            this.cUrl = res.data.data.landingPage;
            let trackUrl = res.data.data.trackUrl;
            this.$axios({
              url: trackUrl,
              method: "get",
            }).then(res => {
              console.log(res)
            });
            console.log(res.data);
          })
      },
      clickUrl() {
        window.location.href = this.cUrl;
      }
    },
    created() {},
    mounted() {
      this.getAdvertisingInfo();
      //mySessionStorage.setItem("openid", "oiuZN6Kj5VB2kiu7ytOWdoznct_Q");
      this.getopenId();
    },
  };
</script>

<style scoped>
  .queryOrder {
    min-height: 100%;
    height: 100%;
    width: 100%;
    max-width: 100%;
    background-color: #e8e9eb;
    float: left;
  }

  .adsense_space {
    width: 100%;
    height: 25%;
  }

  .nav_bar {
    width: 100%;
    height: 46px;
    float: left;
  }

  .car_num_holder {
    width: 100%;
    float: left;
  }

  .bt_qurey {
    width: 80%;
    margin-left: 10%;
    margin-top: 30px;
    border-radius: 5px;
    height: 36px;
    /* position: fixed;
  display: block; */
  }
</style>



// WEBPACK FOOTER //
// src/components/user/payFees/queryPayFees.vue